import script from "./PermissionDeniedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionDeniedModal.vue?vue&type=script&setup=true&lang=js"

import "./PermissionDeniedModal.vue?vue&type=style&index=0&id=30392fa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30392fa5"]])

export default __exports__